import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getModalTranslationKey } from 'hooks/context/modals/utils';
import { useModals } from 'hooks/context/modals';
import { Button, ButtonVariant } from 'components/Button';
import { ModalType } from '../types';

import styles from '../styles.module.scss';

type GenericModalProps = {
  onConfirmClickCallback?: () => void,
  modalType: ModalType;
  modalCategoryTranslationKey: string;
};

export const GenericModal: FC<GenericModalProps> = ({ modalType, modalCategoryTranslationKey, onConfirmClickCallback }) => {
  const { t } = useTranslation('common');
  const { setModalType } = useModals();

  const modalTypeTranslationKey = getModalTranslationKey(modalType);
  if (!modalTypeTranslationKey) return null;

  return <>
    <h1>{t(`${modalCategoryTranslationKey}.${modalTypeTranslationKey}.header`)}</h1>
    <p>{t(`${modalCategoryTranslationKey}.${modalTypeTranslationKey}.blurb`)}</p>
    <div className={styles.buttons}>
      {onConfirmClickCallback && <Button
        variant={ButtonVariant.SECONDARY}
        onClick={
          () => {
            setModalType(undefined);
            onConfirmClickCallback?.();
          }
        }>
          {t('modals.ok')}
        </Button>
      }
      <Button onClick={() => setModalType(undefined)}>{t('modals.cancel')}</Button>
    </div>
  </>
};
